import { ContactFormData } from "./types";

export const initialFormData: ContactFormData = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
  privacyConsent: false,
};

export const contactSubjects = [
  { value: "general", label: "General Inquiry" },
  { value: "products", label: "Product Information" },
  { value: "wholesale", label: "Wholesale Opportunities" },
  { value: "careers", label: "Job Opportunities" },
  { value: "events", label: "Events & Partnerships" },
  { value: "feedback", label: "Feedback & Suggestions" },
  { value: "support", label: "Technical Support" },
  { value: "other", label: "Other" },
];

// Enhanced validation patterns for better UX
export const validationPatterns = {
  email:
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  phone: /^[\+]?[1-9][\d]{0,15}$|^[\(]?[\d\s\-\(\)]{10,}$/,
  name: /^[a-zA-ZÀ-ÿ\s'-]{2,50}$/,
};

// Form field configurations for accessibility and SEO
export const fieldConfigs = {
  firstName: {
    id: "contact-firstName",
    name: "firstName",
    type: "text",
    label: "First Name",
    placeholder: "Enter your first name",
    required: true,
    autoComplete: "given-name",
    maxLength: 50,
  },
  lastName: {
    id: "contact-lastName",
    name: "lastName",
    type: "text",
    label: "Last Name",
    placeholder: "Enter your last name",
    required: true,
    autoComplete: "family-name",
    maxLength: 50,
  },
  email: {
    id: "contact-email",
    name: "email",
    type: "email",
    label: "Email Address",
    placeholder: "your.email@example.com",
    required: true,
    autoComplete: "email",
    maxLength: 254,
  },
  phone: {
    id: "contact-phone",
    name: "phone",
    type: "tel",
    label: "Phone Number",
    placeholder: "(202) 555-1234",
    required: false,
    autoComplete: "tel",
    maxLength: 20,
  },
  subject: {
    id: "contact-subject",
    name: "subject",
    label: "Subject",
    required: true,
  },
  message: {
    id: "contact-message",
    name: "message",
    label: "Message",
    placeholder:
      "How can we help you? Please provide as much detail as possible.",
    required: true,
    minLength: 10,
    maxLength: 2000,
  },
};
